import { LinearProgress, useTheme } from '@mui/material';

export interface IMplProgressProps {
	/* 0 - 100 Value of the bar */
	value: number;
}

export function MplProgress({ value }: IMplProgressProps) {
	const theme = useTheme();

	return (
		<LinearProgress
			variant="determinate"
			value={Math.min(Math.max(value, 0), 100)}
			sx={{
				backgroundColor: theme.palette.solutions?.[200],
				'& .MuiLinearProgress-bar': {
					backgroundColor: theme.palette.primary.main,
				},
			}}
		/>
	);
}
